import type { FC } from 'react';
import { useContext } from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { ScreenSizeContext } from '@wix/da-hooks/pkg/useMeasureElement/ScreenSizeContext';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import isSSR from '@wix/da-shared-react/pkg/utils/isSSR';
import Dumbo from '@wix/da-shared-react/pkg/DeviationViews/Dumbo';
import TierBreadcrumbs from '../../../TierBreadcrumbs';
import TierDescription from '../../../published/TierDescription';
import TierActionsDropdown from '../../../_partials/TierActionsDropdown';

import s from './TierHeaderMobile.scss';

interface Props {
  tier: PapiDeviation;
}

const TierHeaderMobile: FC<Props> = ({ tier }) => {
  // don't render thumb for anon user on ssr because screen size value might be off
  const { width: screenSize } = useContext(ScreenSizeContext);
  const { isLoggedIn } = useContext(SessionContext);
  const coverImage = tier.coverImage;
  const showThumb = coverImage && !coverImage.isDefaultImage && (!isSSR() || isLoggedIn);

  return (
    <div className={s['root']}>
      {showThumb && coverImage && (
        <div className={s['folder-thumb-wrapper']}>
          <Dumbo
            className={s['folder-thumb']}
            deviation={coverImage}
            width={screenSize}
            height={178}
          />
        </div>
      )}
      {showThumb && <div className={s['folder-thumb-overlay']} />}

      <div className={s['top']}>
        <TierBreadcrumbs />
        <BiLoggerContextProvider value={{ sectionname: 'header_actions' }}>
          <div className={s['actions']}>
            <TierActionsDropdown tier={tier} iconSizeOverride="large" />
          </div>
        </BiLoggerContextProvider>
      </div>
      <TierDescription tier={tier} className={s['folder-description']} />
    </div>
  );
};
TierHeaderMobile.displayName = 'TierHeaderMobile';

export default TierHeaderMobile;
